module.exports = __webpack_public_path__ + "static/img/zhengui.2b1e467.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/geren/photos/zhengui.jpeg
// module id = voG0
// module chunks = 36